module.exports = __webpack_public_path__ + "img/chaperonage2.94dc27c2.png";